import { render, staticRenderFns } from "./invalidImage.vue?vue&type=template&id=20c95cca&scoped=true"
import script from "./invalidImage.vue?vue&type=script&lang=js"
export * from "./invalidImage.vue?vue&type=script&lang=js"
import style0 from "./invalidImage.vue?vue&type=style&index=0&id=20c95cca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c95cca",
  null
  
)

export default component.exports